import helper from '../helper'

export const serviceLogActivity = {
  get: (token, params) => helper.get('api/v1/log-activities', token, params)
}
